import React, { PureComponent } from "react";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import {
  HORIZONTAL_ORIENTATION,
  VERTICAL_ORIENTATION,
} from "react-dates/constants";
import "react-dates/lib/css/_datepicker.css";

class DateRangePickerField extends PureComponent {
  state = { focusedInput: null };
  handleFocusChange = (focusedInput) => this.setState({ focusedInput });

  componentDidMount() {
    // use css media quries
    this.isMobile = window.matchMedia("(max-width: 768px)");

    // test on first run
    this.handleIsMobile({ matches: this.isMobile.matches });

    // listen to changes after first run
    this.isMobile.addListener(this.handleIsMobile);
  }

  handleIsMobile = ({ matches }) => this.setState({ isMobile: matches });

  renderError({ error, touched }) {
    if (touched && error) {
      return (
        <div className="invalid-feedback d-block">
          <div className="header">
            <strong>{error}</strong>
          </div>
        </div>
      );
    }
  }

  render() {
    const smallDevice = window.matchMedia("(max-width: 768px)").matches;
    const orientation = smallDevice
      ? VERTICAL_ORIENTATION
      : HORIZONTAL_ORIENTATION;

    const {
      label,
      error,
      meta,
      input: {
        value: { startDate = null, endDate = null },
        onChange,
      },
    } = this.props;
    const { focusedInput = null } = this.state;

    return (
      <>
        <label className="form-label text-uppercase small">{label}</label>
        <div className="mb-3">
          <DateRangePicker
            endDateId="endDate"
            endDate={endDate}
            endDatePlaceholderText="End Date"
            focusedInput={focusedInput}
            onDatesChange={onChange}
            onFocusChange={this.handleFocusChange}
            startDateId="startDate"
            startDate={startDate}
            startDatePlaceholderText="Start Date"
            displayFormat="DD-MM-YYYY"
            hideKeyboardShortcutsPanel={true}
            orientation={orientation}
          />
          {this.renderError(meta)}
        </div>
      </>
    );
  }
}

export default DateRangePickerField;
